import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'navigation';
export const useNavigationTranslation = (): UseTranslationResponse<
  typeof ns
> => useTranslation(ns);

const reused = {
  accounts: '$t(users)',
  workspace: '$t(operator_panel)',
  fs_event_archive: '$t(events_archive)',
  va_event_archive: '$t(video_analytics_archive)',
  videowall: '$t(video_wall)',
  search: '$t(common:search)',
  fs_event_statistic: '$t(statistics)',
  fs_sources: '$t(event_sources)',
  va_sources: '$t(video_analytics_title)',
  vms: '$t(common:vms)',
  handlers: '$t(handling_policies)',
  tasks: '$t(tasks_title)',
  monitoring: '$t(common:monitoring)',
  features: '$t(common:features)',
  notifications: '$t(common:notifications)',
};

export const ruRu = ({
  ...reused,
  cards_and_lists: 'Картотека и списки',
  events_and_video: 'События и видео',
  sources: 'Источники',
  users: 'Пользователи',
  settings_and_catalogs: 'Настройки и справочники',
  administration: 'Администрирование',
  other: '',
}) as Record<string, unknown>;

export const en = ({
  ...reused,
  cards_and_lists: 'Card index and lists',
  events_and_video: 'Events and Video',
  sources: 'Sources',
  users: 'Users',
  settings_and_catalogs: 'Settings and Catalogs',
  administration: 'Administration',
  other: '',
}) as Record<string, unknown>;

export const esEs = ({
  ...reused,
  cards_and_lists: 'Fichero y listas',
  events_and_video: 'Eventos y vídeo',
  sources: 'Fuentes',
  users: 'Usuarios',
  settings_and_catalogs: 'Configuración y catálogos',
  administration: 'Administración',
  other: '',
}) as Record<string, unknown>;

export const ptBr = ({
  ...reused,
  cards_and_lists: 'Fichas e listas',
  events_and_video: 'Eventos e Vídeos',
  sources: 'Fontes',
  users: 'Usuários',
  settings_and_catalogs: 'Configurações e Catálogos',
  administration: 'Administração',
  other: '',
}) as Record<string, unknown>;
